export enum InputTheme {
  Small = 'small',
  Standard = 'standard'
}
